import styled from 'styled-components';
import { Typography } from 'antd';
import colors from '../../styles/colors';

const { Text } = Typography;

export const TextCard = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  padding-right: 15px;
  width: ${props => props.width && '33%'};
`;

export const Title = styled(Text)`
  line-height: 22px;
  color: ${colors.greyText};
  font-size: ${props => props.titlesize || 14}px;
  margin-bottom: 8px;
`;

export const ValueTextCopyable = styled(Text)`
  padding: 0;
  .ant-typography-expand,
  .ant-typography-edit,
  .ant-typography-copy {
    margin: 0 4px 0 0;
  }
`;

export const ValueText = styled(Text)`
  color: ${props => props.color || colors.greyText};
  font-size: ${props => props.valuesize || 14}px;
`;
